import { registerComponent, getComponentConfig } from "helpers";

registerComponent(
  "video-player",
  class VideoPlayer extends HTMLElement {
    async connectedCallback() {
      this.config = getComponentConfig(this);

      if (this.config.type === "youtube") {
        this.previewImageSrc = `https://i.ytimg.com/vi/${this.config.id}/maxresdefault.jpg`;
        this.videoSrc = `https://www.youtube.com/embed/${this.config.id}`;
      } else {
        this.previewImageSrc = await this.fetchVimeoPreviewImageSrc();
        this.videoSrc = `https://player.vimeo.com/video/${this.config.id}`;
      }

      this.bindEvents();
    }

    async fetchVimeoPreviewImageSrc() {
      const response = await fetch(
        `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.config.id}&format=json&width=1200`,
      );
      const data = await response.json();
      return data.thumbnail_url;
    }

    bindEvents() {
      this.renderPreviewImage();
      this.addEventListener("click", this.renderVideo.bind(this));
      this.handleModalContext();
    }

    renderPreviewImage() {
      [this.previewButton] = this.getElementsByTagName("button");
      this.previewImage = document.createElement("img");
      this.previewImage.setAttribute("src", this.previewImageSrc);
      this.previewImage.setAttribute(
        "class",
        "video-player__preview-image fit-image",
      );
      this.previewImage.setAttribute("loading", "lazy");
      this.previewButton.append(this.previewImage);
    }

    renderVideo() {
      this.iframe = document.createElement("iframe");
      const width = this.previewButton.offsetWidth;
      const height = this.previewButton.offsetHeight;

      this.iframe.setAttribute("src", `${this.videoSrc}?autoplay=1`);
      this.iframe.setAttribute("frameborder", "0");
      this.iframe.setAttribute("allowfullscreen", "1");
      this.iframe.setAttribute("allow", "autoplay; encrypted-media");
      this.iframe.setAttribute("class", "video-player__iframe fit-image");
      this.iframe.setAttribute("width", width);
      this.iframe.setAttribute("height", height);
      this.iframe.setAttribute("frameborder", "0");

      this.setAttribute("ready", true);
      this.appendChild(this.iframe);
      this.classList.add("video-player--playing");
    }

    handleModalContext() {
      const modal = this.closest("[data-modal]");

      if (modal) {
        modal.addEventListener("modalOpen", () => {
          // JS sizes the iframe based on the preview image dimensions.
          // But when in a modal, that image has no dimensions.
          // So we remove the lazy loading attribute to trigger a load
          // and then wait for that to complete before rendering the iframe.
          this.previewImage.removeAttribute("loading");
          this.previewImage.addEventListener(
            "load",
            this.renderVideo.bind(this),
          );
        });

        modal.addEventListener("modalClose", () => {
          this.reset();
        });
      }
    }

    reset() {
      this.iframe.remove();
      this.classList.remove("video-player--playing");
    }
  },
);
